import styled from 'styled-components';
import { Card } from 'antd';
import { COLORS } from '../../constants/colors';

export const Container = styled.div`
  padding: 24px;
  max-width: 1200px;
  margin: 0 auto;
`;

export const PageHeader = styled.div`
  margin-bottom: 32px;
  padding-bottom: 16px;
  border-bottom: 2px solid ${COLORS.border};
  
  /* Full-width border extending to edges */
  margin-left: -48px;
  margin-right: -48px;
  padding-left: 48px;
  padding-right: 48px;
  
  @media (max-width: 768px) {
    margin-left: -40px;
    margin-right: -40px;
    padding-left: 40px;
    padding-right: 40px;
  }
`;

export const FormCard = styled(Card)`
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  
  .ant-card-body {
    padding: 32px;
  }
`;
